import { yesNo } from '../common/constant/classification';

/**
 * 予約カレンダーの説明文を作成する。
 * 抽選予約を受け付けている場合にのみ抽選関連の文言表示を行う。
 * @param immediatelyReservationFlag 
 * @param cancelWaitAcceptFlag 
 * @param postponeCancelWaitAcceptFlag 
 * @param isLottery 抽選予約受付可否
 * @returns 
 */
export function getUsageGuidStr(
  immediatelyReservationFlag: string,
  cancelWaitAcceptFlag: string,
  postponeCancelWaitAcceptFlag: string,
  isLottery: boolean,
  isLoggedIn?: boolean
): string {
  let usageGuideStr: string;
  if (isLottery) {
    if (immediatelyReservationFlag === yesNo.yes) {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.7'
      } else {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.8'
      }
    } else {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        if (postponeCancelWaitAcceptFlag === yesNo.yes) {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.9'
        } else {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.11'
        }
      } else {
        if (postponeCancelWaitAcceptFlag === yesNo.yes) {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.10'
        } else {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.12'
        }
      }
    }
  } else {
    if (immediatelyReservationFlag === yesNo.yes) {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.1'
      } else {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.2'
      }
    } else {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        if (postponeCancelWaitAcceptFlag === yesNo.yes) {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.3'
        } else {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.5'
        }
      } else {
        if (postponeCancelWaitAcceptFlag === yesNo.yes) {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.4'
        } else {
          usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.LoggedIn.6'
        }
      }
    }
  }

  if (isLoggedIn !== null && isLoggedIn) {
    if (isLottery) {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.NotLoggedIn.3'
      } else {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.NotLoggedIn.4'
      }
    } else {
      if (cancelWaitAcceptFlag === yesNo.yes) {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.NotLoggedIn.1'
      } else {
        usageGuideStr = 'facilityDetailAvailability.label.reserveUsageGuide.NotLoggedIn.2'
      }
    }
  }
  return usageGuideStr;
}
